import { Box, FormControl, InputLabel, MenuItem, Paper, Select, SelectChangeEvent, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { hearingLossIntensity, hearingLossType } from '../utils/icd10generator';

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary
}));

export function Diagnosis(props: {
    onTypeChange: (arg0: number) => void;
    onIntensityChange: (arg0: number) => void;
    onIntensityToChange: (arg0: number) => void;
}) {
    return (
        <>
            <Stack>
                <Item>
                    <Box sx={{ width: 150 }}>
                        <FormControl fullWidth>
                            <InputLabel id="diagnosis-label">Diagnosis</InputLabel>
                            <Select
                                labelId="diagnosis-label"
                                id="demo-simple-select"
                                // value={age}
                                label="Diagnosis"
                                onChange={(value) => props.onTypeChange(value.target.value as number)}
                            >
                                <MenuItem value={hearingLossType.CONDUCTIVE}>Conductive</MenuItem>
                                <MenuItem value={hearingLossType.SENSORINEURAL}>Sensorineural</MenuItem>
                                <MenuItem value={hearingLossType.MIXED}>Mixed</MenuItem>
                                <MenuItem value={hearingLossType.NONE}>None</MenuItem>
                                <MenuItem value={hearingLossType.UNSPECIFIED}>Unspecified</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                </Item>
                <Item>
                    <Box sx={{ width: 150 }}>
                        <FormControl fullWidth>
                            <InputLabel id="intensity-label">Intensity</InputLabel>
                            <Select
                                labelId="intensity-label"
                                id="demo-simple-select2"
                                // value={age}
                                label="Intensity"
                                onChange={(value) => props.onIntensityChange(value.target.value as number)}
                            >
                                <MenuItem value={hearingLossIntensity.NORMAL}>Normal</MenuItem>
                                <MenuItem value={hearingLossIntensity.MILD}>Mild</MenuItem>
                                <MenuItem value={hearingLossIntensity.MODERATE}>Moderate</MenuItem>
                                <MenuItem value={hearingLossIntensity.MODERATELY_SEVERE}>Moderately Severe</MenuItem>
                                <MenuItem value={hearingLossIntensity.SEVERE}>Severe</MenuItem>
                                <MenuItem value={hearingLossIntensity.PROFOUND}>Profound</MenuItem>
                                <MenuItem value={hearingLossIntensity.UNSPECIFIED}>Unspecified</MenuItem>
                            </Select>
                            <br />
                            to (Optional)
                            <Select
                                labelId="intensity-label"
                                id="demo-simple-select2"
                                // value={age}
                                label="to (Optional)"
                                onChange={(value) => props.onIntensityToChange(value.target.value as number)}
                            >
                                <MenuItem value={hearingLossIntensity.NORMAL}>Normal</MenuItem>
                                <MenuItem value={hearingLossIntensity.MILD}>Mild</MenuItem>
                                <MenuItem value={hearingLossIntensity.MODERATE}>Moderate</MenuItem>
                                <MenuItem value={hearingLossIntensity.MODERATELY_SEVERE}>Moderately Severe</MenuItem>
                                <MenuItem value={hearingLossIntensity.SEVERE}>Severe</MenuItem>
                                <MenuItem value={hearingLossIntensity.PROFOUND}>Profound</MenuItem>
                                <MenuItem value={hearingLossIntensity.UNSPECIFIED}>Unspecified</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                </Item>
            </Stack>
        </>
    );
}
